import {Skeleton} from '@mui/material';

export const SystemEntitiesRowSkeleton = () => {
  return <Skeleton animation="wave" sx={{transform: 'scale(1, 0.69)'}} height={48} />;
};
